module.exports = __webpack_public_path__ + "static/media/rsm-cta-list.d63bddd6.svg";